import { CSSProperties, useCallback, useEffect, useState } from "react";
import { ParallaxImage } from "../ParallaxImage";
import style from "./Article.module.scss";
import { ReadMore } from "./ReadMore/ReadMore";
import cx from "classnames";
import { scrollToTop, useWindowSize } from "../../utils";

import { Headline } from "./Headline/Headline";
import { ColorSection } from "../../ColorContext";
import { VideosSection } from "../VideoSection/VideoSection";
import { VideoSlider } from "./VideoSlider/VideoSlider";
import { ArticleAncor } from "../../AnchorContext";

const getArticle = (id: number): Promise<Page> => {
  return new Promise((resolve) => {
    fetch(`/articles?id=${id}`, {
      headers: {
        accept: "application/json",
      },
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => resolve(data as Page));
  });
};

const Block = (props: PageBlock) => {
  const double = props.elements.length > 1;
  return (
    <ColorSection
      background={props.bgColor || "white"}
      className={`${style.wrapper} `}
      style={{ backgroundColor: props.bgColor || "white" }}
    >
      <div
        className={cx(style.block, {
          [style.blockDouble]: double,
        })}
      >
        {props.title && <h2 dangerouslySetInnerHTML={{__html:props.title}}></h2>}
        <div className={cx({ [style.blockDouble__content]: double })}>
          {props.elements.map((element) => (
            <Element {...element} isSingle={!double}/>
          ))}
        </div>
      </div>
    </ColorSection>
  );
};

const Element = (props: PageElement & {isSingle: boolean}) => {
  const {width} = useWindowSize()
  const mobileStyles : CSSProperties = width < 770 ? {
    margin: '0 -35px',
    width: '100vw',
    height: '100vw'
  } : {}
  switch (props.type) {
    case "img": {
      return (
        <div className={style.element__img} style={{ height: 'unset', ...mobileStyles }}>
          <img
            src={"/" + props.content + ".jpg"}
            alt="article-main"
            style={{objectFit: 'cover', height: '100%'}}
          />
        </div>
      );
    }
    case "text": {
      if(props.title){
        return <div>
          <h3 className={style.element__title} dangerouslySetInnerHTML={{__html: props.title}} />
          <p className={style.element__text} dangerouslySetInnerHTML={{ __html: props.content }} />
        </div>
      }
      return (
        <div
          className={style.element__text}
          dangerouslySetInnerHTML={{ __html: props.content }}
        />
      );
    }
    case "bold-text": {
      return (
        <div
          className={style.element__boldText}
          dangerouslySetInnerHTML={{ __html: props.content }}
        />
      );
    }
    case "video": {
      return <div className={style.element__video}></div>;
    }
  }
};

const GenericArticle = ({ id }: { id: number }) => {
  const [data, setData] = useState<Page | null>(null);
  const getData = useCallback(async () => {
    const data = await getArticle(id);
    setData(data);
  }, [id]);
  useEffect(() => {
    getData();
    // scrollToTop();
  }, [getData]);

  return (
    <>
      {data && (
        <>
          <ArticleAncor.Section className={style.articleBody}>
            <Headline headline={data.headline} />
            {data.blocks.map((block) => (
              <Block {...block} />
            ))}
            <div className={style.wrapper}>
              {/* <div className={style.block}> */}
                <VideoSlider video={data.videos} />
              {/* </div> */}
            </div>
          </ArticleAncor.Section>
        </>
      )}
    </>
  );
};

export const Article = ({ id }: { id: number }) => {
  useEffect(() => {
    scrollToTop();
  }, [id]);
  return (
    <div className={style.article}>
      <GenericArticle id={id} />
      <VideosSection />
      <ReadMore id={id} />
    </div>
  );
};

interface PageElement {
  type: "img" | "text" | "bold-text" | "video";
  title?: string;
  content: string; //src для картинок, текст для текста наверно в виде html
}

interface PageBlock {
  bgColor?: string;
  title?: string;
  elements: PageElement[];
}

export interface Page {
  id: number;
  label: string;
  headline: string;
  blocks: PageBlock[];
  videos: {
    link: string,
    label: string
  }[];
}
export interface Preview {
  id: number;
  title: string;
  description: string;
  preview: string; //src
  label: string;
}
